export enum ContainerLoadingStatus {
    OPEN = 'Open',
    LOADING = 'Loading',
    LOADED = 'Loaded'
}